export default __webpack_public_path__ + "static/media/wheel-indon.7a7318a2.webp";